import React, { Component } from 'react';

import {
    Row,
    Col,
    Table,
    FormGroup, Label, Input, Button
} from 'reactstrap';

import ReactPaginate from 'react-paginate';
import moment from 'moment';
import Checkbox from './forms/fields/checkbox';
import { Player, Controls } from "@lottiefiles/react-lottie-player";

import Isvg from 'react-inlinesvg'
import barsIcon from '../assets/svg/bars-icon.svg';
import { splitDate } from '../views/calendar/helper';

const browserInfo = require('browser-info');


function isNumber(char) {
    if (typeof char !== 'string') {
        return false;
    }
    if (char.trim() === '') {
        return false;
    }

    return !isNaN(char);
}


const USE_FILTER_V2 = true;

/**
* Generate data list with pagination
* @author   Milan Stanojevic
*/
class ListBuilder extends Component {
    constructor(props) {
        super(props);
        this.columnVisibilityRef = React.createRef();
        const existingFilter = props?.params?.filter || '';

        this.barsMenuContainer = React.createRef();
        this.topScrollRef = React.createRef();
        this.bottomScrollRef = React.createRef();


        this.state = {
            filter: existingFilter,
            // lastChangeFilter: null
            selectedItems: [],

            filterV2: existingFilter,
            isFilterV2InFocus: false,
        };
    }
    syncScroll = (source) => {
        if (!this.props.bothSideSidebars) return;
        const top = this.topScrollRef?.current;
        const bottom = document.getElementsByClassName('table-responsive')?.[0];

        if (bottom) {
            const styles = window?.getComputedStyle(bottom);
            if (styles.scrollbarWidth === 'thin')
                bottom.style.scrollbarWidth = "auto";

        }

        if (source === "top") {
            if (bottom)
                bottom.scrollLeft = top?.scrollLeft;
        } else {
            if (top)
                top.scrollLeft = bottom?.scrollLeft;
        }
    };
    handleClickOutsideBarsMenuContainer = (event) => {
        if (event && event.target && this.barsMenuContainer && this.barsMenuContainer.contains && !this.barsMenuContainer.contains(event.target)) {
            if (this.state.activeBarsMenu) {
                this.setState({ activeBarsMenu: false })
            }
        }
    }

    handleEnterPress = (e) => {
        if (USE_FILTER_V2 && this.state.isFilterV2InFocus && e?.key === 'Enter') {
            this.props.updateMultipleParams?.([{ name: 'filter', value: this.state.filterV2 }, { name: 'page', value: 0 }], true);
        }


        if (this.props.bothSideSidebars) {
            const scrollAmount = 40;
            if (this.state.browserName === 'Safari') {
                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    if (this.topScrollRef?.current) {
                        this.topScrollRef?.current.scrollBy({
                            left: scrollAmount,
                        });
                    }
                }
                else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    this.topScrollRef?.current.scrollBy({
                        left: -scrollAmount,
                    });
                }
            }

        }

    }
    getBrowserData = () => {
        let browserName = browserInfo();
        let userAgent = navigator?.userAgent;
        let browserNameUA = 'No browser detection'
        if (userAgent.match(/chrome|chromium|crios/i)) {
            browserNameUA = "Chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
            browserNameUA = "Firefox";
        } else if (userAgent.match(/safari/i)) {
            browserNameUA = "Safari";
        } else if (userAgent.match(/edg/i)) {
            browserNameUA = "Edge";
        } else if (userAgent.match(/curoflow-app/i)) {
            browserNameUA = "Curoflow App";
        }
        this.setState({
            browserName: browserName.name,
            browserNameUA: browserNameUA
        }, () => {
            if (typeof window !== 'undefined' && window.innerWidth && window.innerWidth < 768) {
                if ((userAgent.indexOf("FBAN") > -1) || (userAgent.indexOf("FBAV") > -1)) {
                    browserNameUA = 'Facebook'
                } else if (userAgent.indexOf("Instagram") > -1 || userAgent.indexOf("Twitter") > -1 || userAgent.indexOf("LinkedIn") > -1) {
                    browserNameUA = 'Facebook'
                } else if (userAgent.indexOf("SamsungBrowser") > -1) {
                    browserNameUA = 'Samsung Browser'
                }

                this.setState({
                    browserNameUA: browserNameUA
                })
            }

        })
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('keydown', this.handleEnterPress);
        document.addEventListener('mousedown', this.handleClickOutsideBarsMenuContainer);

        this.syncScroll();
        setTimeout(() => {
            this.syncScroll();
        }, 1000);
        setTimeout(() => {
            this.syncScroll();
        }, 1000 * 2);

        this.getBrowserData();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keydown', this.handleEnterPress);
        window.removeEventListener('mousedown', this.handleClickOutsideBarsMenuContainer);

    }
    handleClickOutside = (event) => {
        if (this.columnVisibilityRef && this.columnVisibilityRef.contains && !this.columnVisibilityRef.contains(event.target)) {
            this.setState({ columnVisibilityMenu: null })
        }
    }

    updateColumnVisibility = (name) => {
        if (this.props.updateListBuilderFields && this.props.columnVisibility) {
            this.props.updateListBuilderFields(this.props.columnVisibility, name, () => {
                if (this.props.get) {
                    this.props.get()
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.updateFilterField != this.props.updateFilterField) {
            let params = this.props.params;
            if (params.filter != this.state.filter) {
                this.setState({
                    filter: USE_FILTER_V2 ? '' : params.filter ? params.filter : '',
                    filterV2: USE_FILTER_V2 ? params.filter ? params.filter : '' : '',
                })
            }
        }

        if (this.props.params && prevProps.params && JSON.stringify(this.props.params) !== JSON.stringify(prevProps.params)) {
            let params = this.props.params
            if (params.filter != this.state.filter) {
                this.setState({
                    filter: USE_FILTER_V2 ? '' : params.filter ? params.filter : '',
                    filterV2: USE_FILTER_V2 ? params.filter ? params.filter : '' : '',
                })
            }
        }
        if (prevProps?.items !== this.props.items && this.props.actionBars) {
            this.checkActionTdHeight();
        }
    }
    checkFilterDelay = () => {
        if (USE_FILTER_V2) return;
        if (this.lastChangeFilter && this.props.filterDelay) {
            let delay = new Date().getTime() - this.lastChangeFilter;
            let delayTime = 100;
            if (this.props.filterDelay > 100) {
                delayTime = this.props.filterDelay - 100;
            }
            if (delay > delayTime) {
                this.props.updateMultipleParams?.([{ name: 'filter', value: this.state.filter }, { name: 'page', value: 0 }], true)
                this.lastChangeFilter = null
                // this.setState({ lastChangeFilter: null }, () => {

                // })
            }
        }
    }
    checkActionTdHeight = () => {
        const itemsLength = this.props.items?.length;

        if (itemsLength > 0) {
            for (let i = 0; i < itemsLength; i++) {
                let trHeight = document.getElementById(`tr-${i}`)?.offsetHeight;
                let actionTdHeight = document.getElementById(`action-td-${i}`)?.offsetHeight + 2;
                if (!trHeight || !actionTdHeight) continue;
                if (actionTdHeight < trHeight) {
                    document.getElementById(`action-td-${i}`).style.height = trHeight + 'px';
                }
            }
        }
    }
    render() {
        let params = this.props.params;

        const multiselect = this.props.multiselect;

        const placeholder = 'Type text...'.translate(this.props.lang);

        const tableWidth = this.props.bothSideSidebars ? document.getElementById('list-builder-table-id')?.offsetWidth : null;
        return (
            <Row className="list-builder-wrap">
                {
                    this.props.upperCustomFilters ?
                        <Col lg='12'>
                            {this.props.upperCustomFilters}
                        </Col>
                        :
                        null
                }
                {
                    !this.props.hideEntries ?
                        <Col lg="6" className='flex-center-space-between'>
                            <FormGroup>
                                <Label>{'Show'.translate(this.props.lang)}
                                    <Input type="select" className="entries" value={params.entries} onChange={(e) => this.props.updateMultipleParams([{ name: 'entries', value: e.target.value }, { name: 'page', value: 0 }], true)}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </Input>
                                    {'entries'.translate(this.props.lang)}
                                </Label>
                            </FormGroup>

                            {
                                this.props.columnVisibility ?
                                    <FormGroup className='column-visibility-wrap' >
                                        <div ref={node => this.columnVisibilityRef = node}>
                                            <Button color='primary' disabled={this.props.fields && this.props.fields.length ? false : true} onClick={() => { this.setState({ columnVisibilityMenu: !this.state.columnVisibilityMenu }) }}>{'Column visibility'.translate(this.props.lang)}</Button>
                                            {
                                                this.state.columnVisibilityMenu ?
                                                    <div className='column-visibility-menu-wrap'>
                                                        <div className='column-visibility-menu'>
                                                            {
                                                                this.props.fields && this.props.fields.map((item, idx) => {
                                                                    return (
                                                                        <div
                                                                            className={
                                                                                item.name && this.props.uData && this.props.uData.hiddenListBuilderFields && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility] && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility][item.name] ?
                                                                                    'column-visibility-menu-item hidden-column'
                                                                                    :
                                                                                    'column-visibility-menu-item'
                                                                            }
                                                                            onClick={() => {
                                                                                if (item.name) {
                                                                                    this.updateColumnVisibility(item.name)
                                                                                }
                                                                            }}>
                                                                            {item.label ? item.label.translate(this.props.lang) : ''}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>

                                    </FormGroup>
                                    :
                                    null
                            }
                        </Col>
                        :
                        null
                }

                {
                    this.props.selectData ?
                        <Col lg="2" className={this.props.className ? this.props.className : 'flex-center-space-between'}>
                            <FormGroup>
                                {
                                    this.props.selectLabela ?
                                        <Label>
                                            {this.props.selectLabela.translate(this.props.lang)}
                                        </Label>
                                        :
                                        null
                                }

                                <Input type="select" style={{ paddingRight: 35 }} value={this.props.selectedValue} onChange={(e) => {
                                    this.props.onSelectChange(e.target.value)
                                }}>
                                    {this.props.selectData && this.props.selectData.map(item => {
                                        return (
                                            <option value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </Input>
                            </FormGroup>
                        </Col>
                        :
                        null
                }


                {
                    !this.props.hideFilters ?
                        <Col lg="6" className="filter-results" style={this.props.export && this.props.exportFunction ? { alignItems: 'center' } : {}}>
                            {
                                this.props.export && this.props.exportFunction ?
                                    <FormGroup>
                                        <Button className='export-button-listbuilder' color='primary' onClick={this.props.exportFunction}>{'Export'.translate(this.props.lang)}</Button>
                                    </FormGroup>
                                    :
                                    null
                            }
                            {USE_FILTER_V2 ? <FormGroup className='filter-results-v2-container'>
                                <Input
                                    type='search'
                                    style={{ marginRight: 0 }}
                                    placeholder={placeholder}
                                    value={this.state.filterV2}
                                    onFocus={() => this.setState({ isFilterV2InFocus: true })}
                                    onBlur={() => this.setState({ isFilterV2InFocus: false })}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (this.props.hideDash) {
                                            let dash = value.indexOf('-');
                                            if (dash !== -1) {
                                                if (value[dash - 1] && isNumber(value[dash - 1]) && value[dash + 1] && isNumber(value[dash + 1])) {
                                                    value = value.replace('-', '');
                                                }
                                            }
                                        }
                                        this.setState({ filterV2: value }, () => {
                                            if (this.state.filterV2 === '') this.props.updateMultipleParams?.([{ name: 'filter', value: this.state.filterV2 }, { name: 'page', value: 0 }], true);
                                        });
                                    }}
                                />
                                <Button
                                    color='primary'
                                    size='lg'
                                    onClick={() => {
                                        this.props.updateMultipleParams?.([{ name: 'filter', value: this.state.filterV2 }, { name: 'page', value: 0 }], true);
                                    }}
                                >
                                    {'Search'.translate(this.props.lang)}
                                </Button>
                            </FormGroup> : <FormGroup>
                                <Label style={this.props.filterMoveRight ? { textAlign: 'end', width: '100%' } : {}}>
                                    {'Filter results'.translate(this.props.lang)}
                                    <Input
                                        type="text"
                                        style={{ marginRight: 0 }}
                                        // value={params.filter ? params.filter : ''}
                                        value={this.state.filter}
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            if (this.props.hideDash) {
                                                let dash = value.indexOf('-');
                                                if (dash !== -1) {
                                                    if (value[dash - 1] && isNumber(value[dash - 1]) && value[dash + 1] && isNumber(value[dash + 1])) {
                                                        value = value.replace('-', '');
                                                    }
                                                }
                                            }

                                            if (this.props.filterDelay && value) {
                                                this.setState({ filter: value/*, lastChangeFilter: new Date().getTime()*/ }, () => {
                                                    this.lastChangeFilter = new Date().getTime();
                                                    setTimeout(() => {
                                                        this.checkFilterDelay()
                                                    }, this.props.filterDelay);
                                                })
                                            } else {
                                                this.setState({ filter: value }, () => {
                                                    this.props.updateMultipleParams?.([{ name: 'filter', value: this.state.filter }, { name: 'page', value: 0 }], true)
                                                })
                                            }


                                        }}
                                    // this.props.updateMultipleParams([{ name: 'filter', value: e.target.value }, { name: 'page', value: 0 }], true)
                                    ></Input>
                                </Label>
                            </FormGroup>}

                        </Col>
                        :
                        null
                }
                {
                    this.props.customFilters ?
                        <Col lg='12'>
                            {this.props.customFilters}
                        </Col>
                        :
                        null
                }
                <Col lg="12" className="table-container">
                    {
                        this.props.bothSideSidebars ?
                            <div
                                ref={this.topScrollRef}
                                onScroll={() => this.syncScroll("top")}
                                style={{
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    height: 16,
                                }}
                                className='custom-on-top-list-scrollbar'
                            >
                                <div style={{ width: tableWidth ? `${tableWidth}px` : "1500px", height: 1 }} ></div>
                            </div>
                            :
                            null
                    }

                    <div
                        className="table-container-scroll"
                        // ref={this.bottomScrollRef}
                        onScroll={() => this.syncScroll("bottom")}
                    >

                        {multiselect && this.state.selectedItems?.length && this.state.selectedItems.length > 0 ? <div className='list-builder-multiselect-div-container'>
                            {multiselect.map(obj => <Button onClick={() => {
                                obj?.onClick?.(this.state.selectedItems);
                                this.setState({ selectedItems: [] });
                            }} key={obj?.text} color={obj?.color ?? 'primary'}>
                                {obj?.text}
                            </Button>)}
                        </div> : null}
                        <Table id={'list-builder-table-id'} responsive hover className={`${!this.props.actions ? 'cursor-row' : ''}${this.props.tableClassNameOneItem && this.props.items?.length === 1 ? ` ${this.props.tableClassNameOneItem}` : ''}`}>
                            <thead>
                                <tr style={{ whiteSpace: 'nowrap' }}>
                                    {multiselect && this.props?.items?.length && this.props?.items?.length > 0 ? <th>
                                        <input
                                            type='checkbox'
                                            className='list-builder-multiselect-input'
                                            checked={this.state.selectedItems && this.props.items && this.props.items.length > 0 && this.props.items.every(obj => this.state.selectedItems.includes(obj?._id))}
                                            onChange={() => {
                                                if (!this.props.items || !this.props.items.length) return;

                                                if (this.state.selectedItems && this.props.items && this.props.items.length > 0 && this.props.items.every(obj => this.state.selectedItems.includes(obj?._id))) {
                                                    this.setState({ selectedItems: [] })
                                                } else {
                                                    const ids = this.props.items.map(obj => obj?._id);
                                                    const filtered = ids.filter(id => id ? true : false);
                                                    this.setState({ selectedItems: filtered });
                                                }
                                            }}
                                        />
                                    </th> : null}
                                    {this.props.showNumeration ? <th>#</th> : null}

                                    {
                                        this.props.fields.filter(item => !(item.name && this.props.uData && this.props.uData.hiddenListBuilderFields && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility] && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility][item.name])).map((item, idx) => {
                                            return (
                                                <th className={item.allowSort ? 'sort-enabled' : null} onClick={() => {
                                                    if (item.allowSort) {
                                                        const defaultSort = item.defaultSort === -1 ? -1 : 1;
                                                        this.props.updateSort?.(item.name, !this.props.sortField ? defaultSort : this.props.sortField == item.name && parseInt(this.props.sortType) == 1 ? -1 : 1)
                                                    }
                                                }} key={idx}>{item.label} {item.allowSort ? <span className={this.props.sortField == item.name && parseInt(this.props.sortType) == 1 ? `sort sort-asc` : this.props.sortField == item.name && parseInt(this.props.sortType) == -1 ? 'sort sort-desc' : item.allowSort ? 'sort' : ''}></span> : null}</th>
                                            )
                                        })
                                    }
                                    {this.props.actions ?
                                        <th className="action-td">{this.props.actionLabel ? this.props.actionLabel : 'Action'.translate(this.props.lang)}</th>
                                        :
                                        null}
                                </tr>
                            </thead>
                            <tbody className='list-builder-tbody'>
                                {
                                    this.props.items && this.props.items.length ? this.props.items.map((item, idx) => {
                                        return (
                                            <tr className={item.___className} style={this.props.allowRowClick ? { cursor: 'pointer' } : {}} key={idx} id={`tr-${idx}`} onClick={() => {
                                                if ((!this.props.actions && this.props.onClick) || (this.props.allowRowClick && this.props.onClick)) {
                                                    if (this.props.rawItems)
                                                        this.props.onClick(this.props.rawItems[idx])
                                                    else
                                                        this.props.onClick(item)
                                                }
                                            }}>
                                                {multiselect ? <td>
                                                    <input
                                                        type='checkbox'
                                                        className='list-builder-multiselect-input'
                                                        checked={item?._id && this.state.selectedItems?.includes(item?._id) ? true : false}
                                                        onChange={() => {
                                                            const id = item?._id;
                                                            if (!id) return;
                                                            if (this.state.selectedItems?.includes(id)) {
                                                                this.setState(prev => ({
                                                                    ...prev,
                                                                    selectedItems: prev?.selectedItems?.filter(_id => _id !== id)
                                                                }));
                                                            } else {
                                                                this.setState(prev => ({
                                                                    ...prev,
                                                                    selectedItems: [
                                                                        ...(prev?.selectedItems || []),
                                                                        id
                                                                    ]
                                                                }))
                                                            }
                                                        }}
                                                    />
                                                </td> : null}
                                                {this.props.showNumeration ? <td scope="row">{params.page * params.entries + idx + 1}</td> : null}
                                                {
                                                    this.props.fields.filter(item => !(item.name && this.props.uData && this.props.uData.hiddenListBuilderFields && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility] && this.props.uData.hiddenListBuilderFields[this.props.columnVisibility][item.name])).map((field, fidx) => {
                                                        let itemFieldValue = item[field.name];
                                                        if (field?.fieldWithDuration) {
                                                            let _val = item?.[field?.name];
                                                            if (_val) {
                                                                let splitVal = splitDate(_val);
                                                                if (splitVal?.date && splitVal?.others?.length > 5) {
                                                                    itemFieldValue = <>
                                                                        <div style={{ whiteSpace: 'nowrap' }}>{splitVal.date}</div>
                                                                        <div style={{ whiteSpace: 'nowrap' }}>{splitVal.others}</div>
                                                                    </>
                                                                }

                                                            }
                                                        }
                                                        if (field.type == 'two-rows-text') {
                                                            return (
                                                                <td key={fidx}>
                                                                    {
                                                                        field.strong && field.strong(item) ?
                                                                            <>
                                                                                <strong> {field.beforeText && field.beforeText.condition(item) ? field.beforeText.text : ''}  {field.multilang ? Object.translate(item, field.name, this.props.lang) : Object.get(item, field.name)}</strong> <br /><span className="clinic-subgroup-name">{Object.get(item, field.secondRowName)}</span>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {field.beforeText && field.beforeText.condition(item) ? field.beforeText.text : ''} {field.multilang ? Object.translate(item, field.name, this.props.lang) : Object.get(item, field.name)} <br /><span className="clinic-subgroup-name">{Object.get(item, field.secondRowName)}</span>

                                                                            </>
                                                                    }

                                                                </td>
                                                            )
                                                        } else if (field.type == 'text') {
                                                            return (
                                                                <td key={fidx} style={{ maxWidth: field.maxWidth || field.colMaxWidth, overflow: field.maxWidth ? 'hidden' : 'unset', wordBreak: field.maxWidth ? 'break-all' : 'unset', overflowWrap: field.colMaxWidth ? 'break-word' : 'unset' }}>{field.multilang ? item[field.name] && item[field.name][this.props.lang] : itemFieldValue}</td>
                                                            )
                                                        } else if (field.type == 'checkbox') {
                                                            return (
                                                                <td key={fidx}>
                                                                    <div>
                                                                        <Checkbox checked={item[field.name]} label={field.multilang ? item[field.name] && item[field.name][this.props.lang] : item[field.name]} />
                                                                    </div>
                                                                </td>
                                                            )
                                                        } else if (field.type == 'list') {
                                                            return (
                                                                <td key={fidx}>
                                                                    {
                                                                        item[field.name] ? item[field.name].map((fitem, fitemidx) => {
                                                                            return (
                                                                                <div className="list-item">
                                                                                    {fitem[field.itemName]}

                                                                                    {
                                                                                        field.actions.map((action, aidx) => {
                                                                                            return (
                                                                                                <button key={aidx} onClick={() => action.onClick(item, fitemidx)}>{action.component}</button>
                                                                                            )
                                                                                        })

                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                            :
                                                                            null
                                                                    }
                                                                </td>
                                                            )

                                                            // Four new types: 'date', 'custom-list', 'status' and 'count-of-total'
                                                        } else if (field.type === 'date') {
                                                            // show date for createdAt, updatedAt...

                                                            return (
                                                                <td key={fidx}>
                                                                    {moment(item[field.name]).format('DD.MM.YYYY HH:mm')}
                                                                </td>
                                                            )


                                                        } else if (field.type === 'custom-list') {
                                                            /* 
                                                            Info: If you need to combine multiple different fields from same object
                                                            Example: 
                                                            {
                                                                type: 'custom-list',
                                                                label: 'Administered info'.translate(this.props.lang),
                                                                items: [{label: 'Administered by'.translate(this.props.lang), name: 'administeredBy'},
                                                                    {label: 'Administered at'.translate(this.props.lang), name: 'administeredAt'},
                                                                    {label: 'Administration date'.translate(this.props.lang), name: 'administrationDate'}]
                                                            }
                                                            */
                                                            return (
                                                                <td
                                                                    key={fidx}
                                                                    style={{
                                                                        maxWidth: field.maxWidth,
                                                                        overflow: field.maxWidth ? 'hidden' : 'unset',
                                                                        wordBreak: field.maxWidth ? 'break-all' : 'unset',
                                                                    }}
                                                                >
                                                                    {field.items.map((n, idx) => {
                                                                        const value = field.multilang
                                                                            ? item[n.name]?.[this.props.lang] ?? ''
                                                                            : item[n.name] ?? '';

                                                                        return (
                                                                            <div key={idx} style={{ whiteSpace: 'nowrap' }}>
                                                                                <strong>{n.label}:</strong> {value ? value : '-'}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </td>
                                                            );
                                                        } else if (field.type === 'status') {
                                                            /*
                                                              Info: If you need custom text for boolean values ("Active" / "Deleted" by default)
                                                              Example:
                                                              {
                                                                type: 'status',
                                                                label: 'Status'.translate(this.props.lang),
                                                                name: 'isDeleted',
                                                                trueText: 'Disabled',
                                                                falseText: 'Enabled'
                                                              }
                                                            */

                                                            const trueLabel = field.trueText?.translate?.(this.props.lang) || "Deleted".translate(this.props.lang);
                                                            const falseLabel = field.falseText?.translate?.(this.props.lang) || "Active".translate(this.props.lang);

                                                            return (
                                                                <td
                                                                    key={fidx}
                                                                    style={{
                                                                        maxWidth: field.maxWidth,
                                                                        overflow: field.maxWidth ? 'hidden' : 'unset',
                                                                        wordBreak: field.maxWidth ? 'break-all' : 'unset'
                                                                    }}
                                                                >
                                                                    {item[field.name] === true ? (
                                                                        <span className="isDeleted">{trueLabel}</span>
                                                                    ) : (
                                                                        <span className="isActive">{falseLabel}</span>
                                                                    )}
                                                                </td>
                                                            );
                                                        }
                                                        else if (field.type === 'count-of-total') {
                                                            /*
                                                              Info: If you need 'out-of' mode like dose number out of total dose - (4/6) 
                                                              IMPORTANT: "doseNumber" and "totalDoses" are names from specific object!
                                                              Example:
                                                              {
                                                                type: 'count-of-total',
                                                                label: 'Dose info'.translate(this.props.lang),
                                                                firstNumberInputName: 'doseNumber',
                                                                secondNumberInputName: 'totalDoses'
                                                              }
                                                            */

                                                            return (
                                                                <td
                                                                    key={fidx}
                                                                    style={{
                                                                        maxWidth: field.maxWidth,
                                                                        overflow: field.maxWidth ? 'hidden' : 'unset',
                                                                        wordBreak: field.maxWidth ? 'break-all' : 'unset'
                                                                    }}
                                                                >
                                                                    {(() => {
                                                                        const first = item[field.firstNumberInputName];
                                                                        const second = item[field.secondNumberInputName];
                                                                        const ofText = 'of'.translate(this.props.lang);

                                                                        const isEmpty = (v) => v == null || v === '' || v === undefined;

                                                                        if (isEmpty(first) && isEmpty(second)) return '-';
                                                                        if (isEmpty(first)) return `- ${ofText} ${second}`;
                                                                        if (isEmpty(second)) return `${first} ${ofText} -`;
                                                                        return `${first} ${ofText} ${second}`;
                                                                    })()}
                                                                </td>
                                                            );
                                                        }

                                                    })
                                                }
                                                {this.props.actions ?
                                                    <td className={`action-td ${this.props.actionColClassName ? this.props.actionColClassName : ''}`} id={`action-td-${idx}`}>
                                                        {
                                                            (!this.props.actionBars || (this.props.actionBars && this.props.actions?.some?.(action => action.showOutsideOfActionBars))) && this.props.actions && this.props.actions.length ?
                                                                this.props.actions.map((action, aidx) => {
                                                                    if (this.props.actionBars && !action.showOutsideOfActionBars) return null;
                                                                    if (!action.condition || (action.condition && action.condition(item)))
                                                                        return (
                                                                            <button key={aidx} onClick={() => {
                                                                                if (this.props.rawItems) {
                                                                                    action.onClick(this.props.rawItems[idx]);
                                                                                }
                                                                                else {
                                                                                    action.onClick(item)
                                                                                }
                                                                            }}>{action.renderComponent ? action.renderComponent(item) : action.component}</button>
                                                                        )
                                                                })
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.props.actionBars && this.props.actions?.length && this.props.actions?.filter(action => (!action.condition || (action.condition && action.condition(item))) && !action.showOutsideOfActionBars)?.length ?
                                                                <div
                                                                    className={this.props.items?.length === 1 ? "action-bars-list-one-item" : "action-bars-list-builder-wrap"}
                                                                    onClick={() => {
                                                                        let key = `menu-${idx}`;
                                                                        this.setState({ activeBarsMenu: this.state.activeBarsMenu == key ? null : key })
                                                                    }}
                                                                >
                                                                    <Isvg src={barsIcon} />

                                                                    {
                                                                        this.state.activeBarsMenu === `menu-${idx}` ?
                                                                            <div className='action-bars-list-builder-menu-wrap' ref={(node) => this.barsMenuContainer = node}>
                                                                                <div className='action-bars-list-builder-menu' >
                                                                                    {
                                                                                        this.props.actions.map((action, aidx) => {
                                                                                            if (action.showOutsideOfActionBars) return null;
                                                                                            if (!action.condition || (action.condition && action.condition(item)))
                                                                                                return (
                                                                                                    <button key={aidx} onClick={() => {
                                                                                                        if (this.props.rawItems) {
                                                                                                            action.onClick(this.props.rawItems[idx]);
                                                                                                        }
                                                                                                        else {
                                                                                                            action.onClick(item)
                                                                                                        }
                                                                                                    }}>{action.renderComponent ? action.renderComponent(item) : action.component}</button>
                                                                                                )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </td>
                                                    :
                                                    null
                                                }



                                            </tr>
                                        )
                                    })
                                        :
                                        null

                                }
                            </tbody>
                        </Table>
                    </div>
                    {this.props.loading ?
                        <div className="loader-wrap" >
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                            ></Player>

                        </div>
                        :
                        null
                    }

                </Col>
                {
                    !this.props.hidePagination ?
                        <>
                            <Col lg="6">
                                <ReactPaginate
                                    previousLabel={'Previous'.translate(this.props.lang)}
                                    nextLabel={'Next'.translate(this.props.lang)}
                                    breakLabel={'...'}
                                    breakClassName={'page-item disabled'}
                                    breakLinkClassName={'page-link disabled'}
                                    pageCount={this.props.total / params.entries}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={(page) => { this.props.updateParams?.('page', page.selected) }}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}

                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    forcePage={parseInt(params.page)}
                                />
                            </Col>
                            <Col lg="6">
                                <span className="news-counter" >{'Showing'.translate(this.props.lang)}  <span className="colored-green"> {this.props.total ? (params.page * params.entries + 1) : 0} </span> {'to'.translate(this.props.lang)} <span className="colored-green"> {this.props.total < (params.page * params.entries + params.entries * 1) ? this.props.total : (params.page * params.entries + params.entries * 1)} </span>  {'of'.translate(this.props.lang)} <span className="colored-blue"> {this.props.total} </span>  {'entries'.translate(this.props.lang)}</span>
                            </Col>
                        </>
                        :
                        null
                }
            </Row>

        );
    }
}

export default ListBuilder;